export default "__VITE_ASSET__Bha4Pfa8__"